module.exports = __webpack_public_path__ + "img/eagle_prep1_b.a6e5c9b7.png";